import { TaskDataStore } from '@skinsoft/entity';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { EntityFeaturedList } from '@skinsoft/ui';
import { defineComponent } from 'vue';

import { Task } from '@skinsoft/types';
import { toFeatured$ } from '../../serializer/featured';

export const TaskFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityFeaturedList: EntityFeaturedList,
    },
    props: ['targetRouteName'],
    template: require('./task-featured-list.html'),
    data() {
        return {
            featuredStates: TaskDataStore.featuredStates,
            sortFields: TaskDataStore.sortFields,
            serializer: (task: Task) => toFeatured$(task, ''), // '' just for avoiding problem with this at initialization
        }
    },
    mounted() {
        // passing directlt this.$i18n.locale to the toFeatured inside the serializer arrow function
        // was not working as the "this" was not pointing to the TaskFeaturedList class
        const locale = this.getAppLocale()
        this.serializer = (task: Task) => toFeatured$(task, locale)
    },
})
